import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserRole } from '@qc/shared';
import { map, take, filter, switchMap } from 'rxjs/operators';
import { AuthSelectors } from '@/app/+state/auth';

export const adminGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(AuthSelectors.selectAuthInitialized).pipe(
        filter((initialized) => initialized),
        take(1),
        switchMap(() => store.select(AuthSelectors.selectUser)),
        take(1),
        map((user) => {
            if (user && user.role === UserRole.SYSTEM_ADMIN) {
                return true;
            }
            if (user) {
                return router.createUrlTree(['/profile']);
            }
            return router.createUrlTree(['/auth/login']);
        }),
    );
};
